import moment from 'moment'
import { MOMENT_FORMAT_DATE } from '@/helpers'

const getters = {
  isCancelApplied(state,getters,rootState){
    return (rootState.app.Company.billingCancellationDate && rootState.app.Company.billing_anniversary_date) && 
        moment(rootState.app.Company.billingCancellationDate).isSameOrAfter(moment().format(MOMENT_FORMAT_DATE));
  },
  isAnniversaryPassed(state,getters,rootState){
    const currentDate = moment().format(MOMENT_FORMAT_DATE)
    return rootState.app.Company.billing_anniversary_date && 
        moment(currentDate).isAfter(rootState.app.Company.billing_anniversary_date)
  },  
}

export default getters